import React from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Home,
  ChevronDown,
  ChevronUp,
  HardDrive,
  Settings,
  Video,
  Layers,
  User,
  Folder,
  PlayCircle,
  Airplay,
} from "react-feather";
import Avatar from "@mui/material/Avatar";
import {
  CorporateFareTwoTone,
  DashboardTwoTone,
  GroupTwoTone,
  PlayCircleOutlineTwoTone,
  SettingsTwoTone,
  TodayTwoTone,
  TvTwoTone,
} from "@mui/icons-material";

export function SidebarNav({ info, router: { location } }) {
  const navigate = useNavigate();

  const [showSettings, setShowSettings] = React.useState(false);

  const adminRole = info.role.includes("ROLE_ADMIN");

  let pathname = location.pathname;

  const handleDropdown = (e) => {
    const resetStates = () => {
      setShowSettings(false);
    };

    resetStates();

    switch (e) {
      case "settings":
        setShowSettings(true);
        break;
      default:
        break;
    }
  };

  const logOut = async () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner">
        <div id="sidebar-menu" className="sidebar-menu">
          <div style={{ marginBottom: 20, color: "rgba(35, 43, 53)" }}>
            General
          </div>
          <ul>
            <li onClick={() => handleDropdown("dashboard")}>
              <Link to="/" style={{ textDecorationLine: "none" }}>
                <DashboardTwoTone />{" "}
                <span
                  style={{
                    fontSize: "SeagoeUI",
                    marginLeft: 20,
                    color: "black",
                    cursor: "pointer",
                    fontFamily: pathname === "/" ? "SeagoeUIBold" : "SeagoeUI",
                  }}
                >
                  Panou de control
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/partners"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <CorporateFareTwoTone />{" "}
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily:
                      pathname.includes("/partner") ||
                      pathname.includes("/locations")
                        ? "SeagoeUIBold"
                        : "SeagoeUI",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Parteneri
                </span>
              </Link>
            </li>

            <li>
              <Link
                to="/devices"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <TvTwoTone />{" "}
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily: pathname.includes("/devices")
                      ? "SeagoeUIBold"
                      : "SeagoeUI",
                  }}
                >
                  Playere
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="/videos"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <PlayCircleOutlineTwoTone />{" "}
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily: pathname.includes("/videos")
                      ? "SeagoeUIBold"
                      : "SeagoeUI",
                  }}
                >
                  Spoturi
                </span>
              </Link>
            </li>
            {/* <li>
              <Link
                to="/category"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <Layers />{" "}
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily:
                      pathname === "/category" ? "SeagoeUIBold" : "SeagoeUI",
                  }}
                >
                  Categorii
                </span>
              </Link>
            </li> */}

            <li>
              <Link
                to="/campaigns"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <TodayTwoTone />
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily: pathname.includes("/campaigns")
                      ? "SeagoeUIBold"
                      : "SeagoeUI",
                  }}
                >
                  Campanii
                </span>
              </Link>
            </li>
            {/* <li>
              <Link
                to="/loops"
                style={{
                  textDecorationLine: "none",
                }}
              >
                <PlayCircle
                  style={{
                    color: pathname.includes("/loops") ? "black" : "inherit",
                  }}
                />
                <span
                  style={{
                    marginLeft: 20,
                    color: "black",
                    fontFamily: pathname.includes("/loops")
                      ? "SeagoeUIBold"
                      : "SeagoeUI",
                  }}
                >
                  Playlist
                </span>
              </Link>
            </li> */}
            {adminRole && (
              <li>
                <Link
                  to="/users"
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <GroupTwoTone />
                  <span
                    style={{
                      marginLeft: 20,
                      color: "black",
                      fontFamily: pathname.includes("/users")
                        ? "SeagoeUIBold"
                        : "SeagoeUI",
                    }}
                  >
                    Utilizatori
                  </span>
                </Link>
              </li>
            )}
            {adminRole && (
              <li>
                <a onClick={() => setShowSettings(!showSettings)}>
                  <SettingsTwoTone />
                  <span style={{ fontSize: "SeagoeUI", marginLeft: 20 }}>
                    Setari
                  </span>
                  {showSettings ? (
                    <ChevronUp className="chevron" />
                  ) : (
                    <ChevronDown className="chevron" />
                  )}
                </a>

                <ul
                  className={
                    showSettings ? "sidebar-dropdown show" : "sidebar-dropdown"
                  }
                >
                  <li>
                    <Link
                      to="/logs"
                      style={{
                        textDecorationLine: "none",
                        color: "black",
                        paddingLeft: 60,
                        fontFamily: pathname.includes("/logs")
                          ? "SeagoeUIBold"
                          : "SeagoeUI",
                      }}
                      onClick={() => handleDropdown("settings")}
                    >
                      Loguri
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </div>
        <div className="overview-sidebar">
          <div className="avatar-sidebar">
            <div className="avatar-top-right">
              <p className="role-sidebar">Healthcare TV</p>
            </div>
            <Avatar
              className="avatar-popover"
              alt={info.name}
              sx={{
                width: 45,
                height: 45,
                border: (theme) => `solid 2px white`,
              }}
            >
              {info.name.charAt(0).toUpperCase()}
            </Avatar>
          </div>
          <p className="name-sidebar">{info.name}</p>
          <p className="email-sidebar">{info.email}</p>
          <div className="button-sidebar" onClick={logOut}>
            <p
              style={{
                color: "#fff",
                fontFamily: "SeagoeUIBold",
                fontSize: "0.8rem",
              }}
            >
              Log out
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

export default withRouter(SidebarNav);
